import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { distinctUntilChanged, shareReplay, tap } from 'rxjs/operators';
import { catchError, switchMap, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import {HOST_NAME, LICENCE} from 'src/app/global.tokens';
import { LogExceptionService } from '../utils/log-exception.service';
import {getApp} from '@angular/fire/app';
import {initializeFirestore} from '@angular/fire/firestore';
import { BaseHttpFirebaseService } from './base-http-firebase.service';

@Injectable({
  providedIn: 'root'
})
export class BaseFirebaseService {
  protected licence: string;

  private httpFirebaseService: BaseHttpFirebaseService;

  constructor(
    private http: HttpClient,
    public afAuth: AngularFireAuth,
    public afs: AngularFirestore,
    @Inject(HOST_NAME) public hostName
  ) {
    this.logExceptionService = inject(LogExceptionService);
    this.licence = inject(LICENCE);
    BaseFirebaseService.applyFirebaseConfig(this.afs, this.licence);
    this.httpFirebaseService = inject(BaseHttpFirebaseService)
  }
  public static applyFirebaseConfig(afs: AngularFirestore, licence: string) {
    (afs.firestore as any)._delegate = initializeFirestore(getApp(), {}, (licence === 'bison_win') ? 'bisonwin' : environment.firebaseDatabaseName || '(default)');
  }

  private logExceptionService: LogExceptionService;

  public setApiUrl(apiUrl?: string) {
    this.httpFirebaseService.setApiUrl(apiUrl);
  }

  public get<T>(url: string, withCredentials: boolean = true): Observable<T> {
    return this.httpFirebaseService.get<T>(url, withCredentials);
  }

  public post<T1, T2>(url: string, request: T1, withCredentials: boolean = true) {
    return this.httpFirebaseService.post<T1, T2>(url, request, withCredentials);
  }

  public getDocumentDB<T>(path: string): Observable<T> {
    return this.httpFirebaseService.getDocumentDB<T>(path);
  }

  public getSnapshotDocument<T>(path: string) {
    return this.httpFirebaseService.getSnapshotDocument<T>(path);
  }

  public addDocument<T>(document: T, path: string) {
    return this.httpFirebaseService.addDocument<T>(document, path)
  }

  public setDocument<T>(document: T, path: string, isMerge: boolean) {
    return this.httpFirebaseService.setDocument<T>(document, path, isMerge);
  }

  public deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) return false;
  
    for (const key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) return false;
    }
  
    return true;
  }
}
